import React from 'react';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

// MUI v0
import MuiThemeProviderV0 from 'material-ui/styles/MuiThemeProvider';
import getMuiThemeV0 from 'material-ui/styles/getMuiTheme';

// MUI v4
import { ThemeProvider as MuiThemeProviderV4, StylesProvider, jssPreset } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { create } from 'jss';
import rtl from 'jss-rtl';

import { store } from './store';
import i18n from '../i18n';
import themeV0 from '../theme';
import themeV4 from '../theme/themeV4';
import themeV4RTL from '../theme/themeV4RTL';
import StyleManagerProvider from '@/styles/StyleManagerProvider';
import CustomDateFnsUtils from '@/utils/DateFnsUtils'; 

// Components
import NavigationHandler from '@/components/NavigationHandler';
import AuthGate from '@/components/AuthGate'; // RESTORED
import RouterWrapper from './router/RouterWrapper'; 

const ReduxProvider = Provider as any;
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const App: React.FC = () => {
  const isRtl = i18n.dir() === 'rtl';
  const activeThemeV4 = isRtl ? themeV4RTL : themeV4;

  return (
    <ReduxProvider store={store}>
      <I18nextProvider i18n={i18n}>
        <StyleManagerProvider>
          <MuiThemeProviderV0 muiTheme={getMuiThemeV0(themeV0)}>
            <StylesProvider jss={jss} injectFirst>
              <MuiThemeProviderV4 theme={activeThemeV4}>
                <MuiPickersUtilsProvider utils={CustomDateFnsUtils}>
                  <CookiesProvider>
                    <DndProvider backend={HTML5Backend}>
                      <BrowserRouter>
                        <NavigationHandler />
                        
                        {/* AuthGate blocks rendering until User/Account is ready */}
                        <AuthGate>
                            <RouterWrapper />
                        </AuthGate>
                        
                      </BrowserRouter>
                    </DndProvider>
                  </CookiesProvider>
                </MuiPickersUtilsProvider>
              </MuiThemeProviderV4>
            </StylesProvider>
          </MuiThemeProviderV0>
        </StyleManagerProvider>
      </I18nextProvider>
    </ReduxProvider>
  );
};

export default App;